import {UntypedFormGroup, UntypedFormControl, Validators} from '@angular/forms';

export class CrumbsSearchModel {
  crumbsAccountForm = new UntypedFormGroup({
    'company': new UntypedFormControl(''),
    'contact': new UntypedFormControl(''),
    'contactPartyRoleId': new UntypedFormControl(''),
    'companyPartyRoleId': new UntypedFormControl(''),
    'accountName': new UntypedFormControl(''),
    'firstName': new UntypedFormControl(''),
    'lastName': new UntypedFormControl(''),
    'mobile': new UntypedFormControl(''),
    'email': new UntypedFormControl('')
  });
}
